import React from 'react';
import {BrowserRouter as Router, Route, HashRouter,Switch} from 'react-router-dom';


import {Main} from './components/main'
import {Reports} from './components/reports'
import {ReportsDetails} from './components/reportsdetails'

import './styles/header.css'
import {JSClient} from "./components/common";
import {Approvals} from "./components/approvals";
import {InvoiceLifecycle} from "./components/lifecycle";
import {Approvals2} from "./components/approvals2";

class App extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: "nobody"
        };
        this.clientLoaded = this.clientLoaded.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }

    render() {
        return (
            <div id="b">
                <div className={"navbar"}>
                    <span className="selected"><a href="/" style={{"font-size":"x-large"}}>Veritas</a></span>
                    <span className="selected"><a className={"right"} href={""}>Hi {this.state.user}!!</a></span>
                    <img src={"https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" + this.state.user}/>
                </div>
                <HashRouter>
                <div>
                    <Switch>
                        <Route exact path="/" component={Approvals}/>
                        <Route exact path="/approvals" component={Approvals2}/>
                        <Route exact path="/lifecycle" component={InvoiceLifecycle}/>
                        <Route exact path="/main" component={Main}/>
                        <Route exact path="/searches" component={Reports}/>
                        <Route path="/searches/:id/" component={ReportsDetails}/>
                    </Switch>
                </div></HashRouter>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js